import React, { useState, useEffect, useTransition } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { enqueueSnackbar, closeSnackbar } from "notistack";
import Header from "../../components/header/Header";
import WelcomeCard from "../../components/login/WelcomeCard";
import Inputs from "../../components/inputs/Inputs";
import Input from "../../components/inputs/_Input";
import Button from "../../components/button/Button";
import { ReactComponent as LoginCross } from "../../assets/icons/login/login-cross.svg";
import { ReactComponent as LoginEye } from "../../assets/icons/login/login-close-eye.svg";
import { useTranslation } from "react-i18next";
import imgParallax from "../../assets/icons/login/3d-rendering-triangle-water.png";

import "./Login.css";
import ParallaxImage from "../../components/ParallaxImage/ParallaxImage";

const Login = () => {
  const { t } = useTranslation();
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState(t("authorization.login-error"));
  const [passwordError, setPasswordError] = useState(
    t("authorization.login-error")
  );
  const [loginDirty, setLoginDirty] = useState(false);
  const [passwordDirty, setPasswordDirty] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (loginError || passwordError) {
      setFormValid(false);
    } else {
      setFormValid(true);
    }
  }, [loginError, passwordError]);

  const blurHandler = (e) => {
    switch (e.target.name) {
      case "login":
        setLoginDirty(true);
        break;
      case "password":
        setPasswordDirty(true);
        break;
      default:
        break;
    }
  };

  const loginHandler = (e) => {
    setLogin(e.target.value);
    const emailRegex =
      /^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|(\+?\d{1,4}[-.\s]?)?(\(?\d{1,4}\)?[-.\s]?)?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{4,9})$/;
    if (!e.target.value) {
      setLoginError(t("authorization.login-error"));
    } else if (!emailRegex.test(e.target.value)) {
      setLoginError(t("authorization.login-error2"));
    } else {
      setLoginError("");
    }
  };

  const passwordHandler = (e) => {
    setPassword(e.target.value);
    if (e.target.value.length < 4) {
      setPasswordError(t("authorization.password-error1"));
      if (!e.target.value) {
        setPasswordError(t("authorization.password-error2"));
      }
    } else {
      setPasswordError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loginError == "" && passwordError == "") {
      try {
        console.log("====================================");
        console.log(typeof password);
        console.log("====================================");
        const response = await axios.post(
          `https://api-ru.fynex.cc/api/api/token`,
          { email: login, password: String(password) },
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        localStorage.setItem("token", response.data.access_token);

        const userToken = localStorage.getItem("token");
        const userDataResponse = await axios.get(
          `https://api-ru.fynex.cc/api/api/users/me`,
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );

        const userData = userDataResponse.data;
        localStorage.setItem("userEmail", userData.email);
        localStorage.setItem("userName", userData.name);
        localStorage.setItem("userSurname", userData.surname);
        localStorage.setItem("isLoggedIn", true);

        navigate("../market?symbol=BTCUSDT", { replace: true });
        window.location.reload();
      } catch (error) {
        enqueueSnackbar(
          `${t("landing.err")}: ${
            error.response?.data?.detail?.msg || t("authorization.unknow-error")
          }`,
          {
            action: (snackbarId) => (
              <button
                className="close-button"
                onClick={() => closeSnackbar(snackbarId)}
              >
                <LoginCross />
              </button>
            ),
            variant: "error",
            className: "snackerror",
          }
        );
      }
    } else {
      console.log(loginError, "loginError");
      console.log(passwordError, "passwordError");
      enqueueSnackbar(
        `${t("landing.err")}: ${loginError == "" ? passwordError : loginError}`,
        {
          action: (snackbarId) => (
            <button
              className="close-button"
              onClick={() => closeSnackbar(snackbarId)}
            >
              <LoginCross />
            </button>
          ),
          variant: "error",
          className: "snackerror",
        }
      );
    }
  };

  return (
    <div className="container">
      <div className="container-left-image">
        <ParallaxImage
          containerClassName="container"
          imageClassName="left-image"
          src={imgParallax}
          alt="Parallax"
        />
      </div>

      <div className="login">
        {/* <Header/> */}
        <div className="auth-wrapper">
          <div className="auth">
            <WelcomeCard text={t("authorization.welcome")} />

            <Inputs>
              {console.log(loginDirty, loginError)}
              {loginDirty && loginError && (
                <div className="error">{loginError}</div>
              )}
              {}
              <Input
                name="login"
                placeholder={t("authorization.input1")}
                value={login}
                onChange={loginHandler}
                onBlur={blurHandler}
                icon={<LoginCross onClick={() => setLogin("")} />}
              />

              {passwordDirty && passwordError && (
                <div className="error">{passwordError}</div>
              )}
              <Input
                name="password"
                type={passwordShown ? "text" : "password"}
                placeholder={t("authorization.input2")}
                value={password}
                onChange={passwordHandler}
                onBlur={blurHandler}
                icon={
                  <LoginEye onClick={() => setPasswordShown(!passwordShown)} />
                }
              />
            </Inputs>

            <div className="action">
              <Button
                text="Войти"
                disabled={!formValid}
                onClick={handleSubmit}
              />
              <p onClick={() => navigate("/recovery")}>
                {t("authorization.forgotPass")}
              </p>
            </div>

            <p>
              {t("authorization.notHaveAcc")}{" "}
              <Link to="/SignUp">{t("authorization.reg")}</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
